/**
 * Menu for a clinic with the BookMyDentist only flag: patients, appointments,
 * the booking setup pages, staff and the booking analytics. Keys are the KEY
 * values in new.routes.tsx.
 *
 * Inventory (8, 148), Dental labs (11) and Room allocation (63) are kept here
 * on purpose: their own flags still decide them in App.tsx, which is how the
 * other admin toggles add their module on top of this mode.
 */

type NavRoute = { KEY: number; SUBNAV?: NavRoute[] };

/** Top-level key -> the child keys kept under it, or "all" for the whole subtree. */
const KEPT: Record<number, number[] | "all"> = {
  1: "all", // Dashboard
  2: "all", // Patients
  6: [61, 62, 63], // Make An Appointment, Appointments, Room Allocation
  91: "all", // My Appointment
  12: "all", // SMS
  14: [146, 147, 148], // Analytics: Appointments, BookMyDentist, Inventory
  7: [71, 73, 77], // Clinical settings: Manage Time, Manage Purpose, Booking
  5: "all", // Staff
  8: "all", // Inventory
  11: "all", // Dental labs
};

export function filterRoutesForBookMyDentistOnly<T extends NavRoute>(routes: T[]): T[] {
  return routes.flatMap((route) => {
    const kept = KEPT[route.KEY];
    if (!kept) return [];
    if (kept === "all" || !route.SUBNAV?.length) return [route];
    return [{ ...route, SUBNAV: route.SUBNAV.filter((sub) => kept.includes(sub.KEY)) }];
  });
}
